import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Plus, Edit2, Trash2 } from "lucide-react";
import { Modal } from "./Brands";

const empty = { name: "", order: 0, status: "active" };

export default function Floors() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => api.get("/floors").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    const payload = { ...form, order: parseInt(form.order || 0, 10) };
    if (modal === "new") await api.post("/floors", payload);
    else await api.patch(`/floors/${modal}`, payload);
    setModal(null); load();
  };

  return (
    <Layout title="Floors" subtitle="Master"
      action={<button className="btn-dark flex items-center gap-2" onClick={() => { setForm(empty); setModal("new"); }} data-testid="add-floor-btn"><Plus size={14} /> Add floor</button>}>
      <div className="card-sharp">
        <table className="fin">
          <thead><tr><th>Order</th><th>Name</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {items.map((f) => (
              <tr key={f.id} data-testid={`floor-row-${f.id}`}>
                <td className="font-mono text-[12px]">{f.order}</td>
                <td className="font-medium">{f.name}</td>
                <td><span className={`badge badge-${f.status}`}>{f.status}</span></td>
                <td className="text-right">
                  <button className="btn-outline mr-2" style={{padding:"6px 10px"}} onClick={() => { setForm(f); setModal(f.id); }}><Edit2 size={12} /></button>
                  <button className="btn-outline" style={{padding:"6px 10px"}} onClick={async () => { if (confirm("Delete floor?")) { await api.delete(`/floors/${f.id}`); load(); } }}><Trash2 size={12} /></button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="4" className="text-center py-8 text-[#8C8C8C]">No floors yet.</td></tr>}
          </tbody>
        </table>
      </div>

      {modal && (
        <Modal onClose={() => setModal(null)} title={modal === "new" ? "Add floor" : "Edit floor"}>
          <form onSubmit={save} className="space-y-4">
            <div><div className="label-tiny mb-1.5">Name</div><input className="fin" required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} data-testid="floor-name" /></div>
            <div><div className="label-tiny mb-1.5">Sort order (negative for basements)</div><input type="number" className="fin" value={form.order} onChange={(e) => setForm({...form, order: e.target.value})} data-testid="floor-order" /></div>
            <div><div className="label-tiny mb-1.5">Status</div>
              <select className="fin" value={form.status} onChange={(e) => setForm({...form, status: e.target.value})}>
                <option value="active">Active</option><option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="flex justify-end gap-2 pt-2">
              <button type="button" className="btn-outline" onClick={() => setModal(null)}>Cancel</button>
              <button type="submit" className="btn-dark" data-testid="save-floor-btn">Save</button>
            </div>
          </form>
        </Modal>
      )}
    </Layout>
  );
}
